import getCurrentTariffByProduct from './getCurrentTariffByProduct';

/**
 * Generates the title for a selected product.
 *
 * @param product
 * @return {`${string} ${*} license`}
 */
export default (product) => {
    const currentTariffId = getCurrentTariffByProduct(product);
    return `${Number(currentTariffId) === Number(product?.tariff?.tariff_id)
        ? 'Renew'
        : ''} ${product?.product_name ?? ''} license`
}
